<web-settings-body>
    <web-settings-breadcrumbs>
        <div class="breadcrumb-icon" (click)="setSelectedTheme()">
            <a [tooltip]="'site_styles' | translate" placement="bottom">
                <img
                    class="first-breadcrumb-icon"
                    src="./assets/img/websites/lpc-theme-settings-icon.svg"
                    alt="lpc-theme-settings-icon"
                />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="lpc-breadcrumb-arrow-icon"
            />
        </div>
        <div class="breadcrumb-icon" (click)="setSelectedColumn(form.parentId())">
            <a [tooltip]="'control_block' | translate" placement="bottom">
                <img class="first-breadcrumb-icon" src="assets/img/websites/lpc-block-icon.svg" alt="lpc-block-icon" />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="lpc-breadcrumb-arrow-icon"
            />
        </div>
        <div class="breadcrumb-icon">
            <img src="./assets/img/websites/lpc-column-icon.svg" class="first-breadcrumb-icon" alt="lpc-column-icon" />
        </div>
        <div class="breadcrumb-text">
            <span>{{ "control_structure" | translate }}</span>
        </div>
    </web-settings-breadcrumbs>

    <div class="panel-options-body overflow-wrapper">
        <form class="form form-horizontal" (submit)="$event.preventDefault()">
            <div class="form-row">
                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_gap" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-input-num
                            suffixText="px"
                            [min]="0"
                            [max]="100"
                            [value]="form.gapXValue().value()"
                            (valueChange)="form.setGapX($event)"
                        />
                    </div>
                    <div class="col-xs-6">
                        <sp-input-num
                            suffixText="px"
                            [min]="0"
                            [max]="100"
                            [value]="form.gapYValue().value()"
                            (valueChange)="form.setGapY($event)"
                        />
                    </div>
                </div>
            </div>
        </form>
    </div>
</web-settings-body>
